import React from 'react';
import { ProducerLabel as StyledProducerLabel } from './ProducerLabel.styled';

export interface ProducerLabelProps {
  children: React.ReactNode;
  className?: string;
}

export function ProducerLabel({ children, className }: ProducerLabelProps) {
  return <StyledProducerLabel className={className}>{children}</StyledProducerLabel>;
}
